/**
 * Import blocks
 */

import "./simple-sitemap";
import "./simple-sitemap-group";


// WEBPACK FOOTER //
// src/blocks/index.js